import { plainToInstance } from "class-transformer";

export function safeAssign<T extends object>(target: T, source: Readonly<T>): T {
    Object.assign(
        target,
        plainToInstance(Object.getPrototypeOf(target).constructor, source, {
            // Exclude properties not decorated with @Expose()
            excludeExtraneousValues: true,
            strategy: "exposeAll",
        })
    );

    return target;
}
